import { SxProps } from "@mui/system";

export const wrapperBox: SxProps = {
    "& .MuiTextField-root": {
        m: 1, width: "25ch"
    },
};